import angular from 'angular';
import 'invision-core';
import { routing as RoutingConfig } from './auto.pay.postpaid.config';
export default angular.module('invision.customercare.customer.configureAutopay', ['invision.core.components']).config(RoutingConfig).name;